import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.string.link.js";
import { get } from 'lodash';
export default /*#__PURE__*/(function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(context, inject) {
    var app, $axios, $config, buildRequest, request, apiUrl, headConfiguration, _app$head, link, meta;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          app = context.app, $axios = context.$axios, $config = context.$config;
          buildRequest = /*#__PURE__*/function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref2) {
              var $axios, $config, host, parts, subdomain, request, _yield$axios$get, _yield$axios$get$data, axios, tenant;
              return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) switch (_context.prev = _context.next) {
                  case 0:
                    $axios = _ref2.$axios, $config = _ref2.$config;
                    host = window.location.hostname;
                    parts = host.split('.');
                    subdomain = parts[0] || 'app';
                    request = {
                      application: 'ausbildungsradar',
                      body: {
                        name: '',
                        color: '#ee5e24'
                      }
                    };
                    _context.prev = 5;
                    // @ts-ignore
                    axios = $axios.create({});
                    axios.setBaseURL($config.public.API_URL);
                    _context.next = 10;
                    return axios.get("/v1/tenants?filter[slug]=".concat(subdomain));
                  case 10:
                    _context.t1 = _yield$axios$get = _context.sent;
                    _context.t0 = _context.t1 === null;
                    if (_context.t0) {
                      _context.next = 14;
                      break;
                    }
                    _context.t0 = _yield$axios$get === void 0;
                  case 14:
                    if (!_context.t0) {
                      _context.next = 18;
                      break;
                    }
                    _context.t2 = void 0;
                    _context.next = 19;
                    break;
                  case 18:
                    _context.t2 = (_yield$axios$get$data = _yield$axios$get.data) === null || _yield$axios$get$data === void 0 ? void 0 : _yield$axios$get$data.data[0];
                  case 19:
                    tenant = _context.t2;
                    request.body.name = tenant.name;
                    request.body.color = tenant.color;
                    _context.next = 26;
                    break;
                  case 24:
                    _context.prev = 24;
                    _context.t3 = _context["catch"](5);
                  case 26:
                    return _context.abrupt("return", request);
                  case 27:
                  case "end":
                    return _context.stop();
                }
              }, _callee, null, [[5, 24]]);
            }));
            return function buildRequest(_x3) {
              return _ref3.apply(this, arguments);
            };
          }();
          _context2.next = 4;
          return buildRequest(context);
        case 4:
          request = _context2.sent;
          apiUrl = get($config, 'WEBMANIFEST_API_URL');
          _context2.prev = 6;
          _context2.next = 9;
          return $axios.post("".concat(apiUrl, "/v1/heads/").concat(request.application), request.body);
        case 9:
          headConfiguration = _context2.sent;
          _app$head = app.head, link = _app$head.link, meta = _app$head.meta;
          link.push({
            hid: 'manifest',
            rel: 'manifest',
            href: headConfiguration.data.manifest_url
          });
          link.push({
            hid: 'favicon',
            rel: 'icon',
            type: 'image/x-icon',
            href: headConfiguration.data.favicon_url
          });
          meta.push({
            hid: 'theme-color',
            name: 'theme_color',
            content: headConfiguration.data.theme_color
          });
          _context2.next = 18;
          break;
        case 16:
          _context2.prev = 16;
          _context2.t0 = _context2["catch"](6);
        case 18:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[6, 16]]);
  }));
  return function (_x, _x2) {
    return _ref.apply(this, arguments);
  };
})();